/**
 * **Gimh**
 *
 * @exports bs_222
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
     * @memberOf module:bs_222
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
    engine.boot = function boot() {
        const container = document.querySelector('.container');
        if (container) {
            let refreshPage = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(container, refreshPage, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(container, refreshPage);
                refreshPage = null;
            });
        }
    };
    /**
       * @memberOf module:bs_222
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const langEl = (document.querySelector('.desplega-idiomas') || {}).textContent || '';
            if (langEl && langEl.match(/english/i)) {
                resolve('en');
                return;
            }
            reject('no_language');
        });
    };
    /**
     * @memberOf module:bs_222
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const containerRooms = document.querySelector('#BookingList');
        if (containerRooms) {
            let refreshPrice = thn.debounce(() => ctx.widget.refresh(), 500);
            thn.observeDom(containerRooms, refreshPrice, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(containerRooms, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_222
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        let nights;
        if (!window.location.href.match(/index/)) {
            return widgetData;
        }
        // Default values
        widgetData.rooms = 1;
        widgetData.adults = 1;
        widgetData.children = 0;
        // Dates
        const dateBegin = (document.querySelector('input#calCheckIn') || {}).value;
        const dateEnd = (document.querySelector('input#calCheckOut') || {}).value;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        // Need to add 1 to the adults count to get the right amount
        const adultsCount = (document.querySelector('#cantidadAdultos') && (document.querySelector('#cantidadAdultos').selectedIndex + 1)) || 2;
        const childrenCount = document.querySelector('#cantidadNinos')?.selectedIndex || 0;
        const babiesEl = document.querySelector('#cantidadNinos2')?.selectedIndex || 0;
        //  Up to one baby is not included in occupancy. Affects Max Occupancy from 2 babies.
        const babiesCount = babiesEl > 1 ? babiesEl : 0;
        widgetData.adults = adultsCount;
        widgetData.children = childrenCount + babiesCount;
        widgetData.guests = widgetData.adults + widgetData.children;
        let priceEls;
        // Price Mobile
        if (thn.data.media.name === 'mobile') {
            priceEls = document.querySelectorAll('.room-description-content');
        }
        else {
            // Price desktop version
            priceEls = [...document.querySelectorAll('.room-reservation .tr_tarifa')].filter((rate) => !rate.querySelector('.condiciones_tarifa')?.innerText.match(/60/));
        }
        widgetData.currency = thn.parseCurrency(document.querySelector('.currency')?.textContent);
        const pricesAvailable = [...priceEls].filter((priceEl) => thn.isVisible(priceEl));
        const prices = [...pricesAvailable].map((price) => thn.parseNumber(price.querySelector('.price')?.textContent)).filter(Boolean);
        if (thn.empty(prices)) {
            widgetData.noRooms = true;
            return widgetData;
        }
        const lowestPrice = Math.min(...prices);
        const pricePerNight = thn.data.media.name === 'mobile' ? lowestPrice : lowestPrice / nights;
        // Price per night
        if (pricePerNight) {
            widgetData.price = pricePerNight;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_222
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v2 = function priceParseData_v2() {
        const widgetData = {};
        // Dates
        const dateBegin = thn.parseUrlParameter('arrive')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        const dateEnd = thn.parseUrlParameter('depart')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        const numberRoomSelected = thn.parseNumber(document.querySelector('div[id*=room].active')?.id) || 1;
        const adultsParam = thn.parseUrlParameter('adult')?.split(',')?.[numberRoomSelected - 1] || 2;
        const childrenParam = thn.parseUrlParameter('child')?.split(',')?.[numberRoomSelected - 1] || 0;
        const infantsParam = thn.parseUrlParameter('infant')?.split(',')?.[numberRoomSelected - 1] || 0;
        const roomInfo = {
            adults: thn.parseNumber(adultsParam) || 2,
            children: thn.parseNumber(childrenParam) + thn.parseNumber(infantsParam) || 0,
            childrenAges: [],
        };
        for (let i = 1; i <= roomInfo.children; i += 1) {
            roomInfo.childrenAges.push(i < childrenParam ? 10 : 1);
        }
        widgetData.roomsDispo = [roomInfo];
        // Prices & Currency || No Rooms
        const roomPrices = [...document.querySelectorAll('div[id*=room].active .room-price__column span[class*=bold]')].map((price) => thn.parseNumber(price.textContent));
        const currency = thn.parseCurrency(document.querySelector('#currencyDropDownId a.selected')?.textContent);
        if (!thn.empty(roomPrices) && currency && nights) {
            widgetData.price = Math.min(...roomPrices) / nights;
            widgetData.currency = currency;
            widgetData.set = true;
            return widgetData;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_222
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingConfirmationEl = document.querySelector('#datosreserva p');
        const bookingConfirmationText = bookingConfirmationEl?.innerText;
        const dataPurchase = window.dataLayer.find((item) => item[0] === 'event' && item[1] === 'purchase');
        const bookingIdV2 = document.querySelector('.abp-widget-wrapper .row .row>.d-flex>.fw-bold')?.textContent?.trim();
        if (bookingConfirmationText === 'Información de la reserva:') {
            // dates
            const bookingTable = document.querySelector('#datosreserva tbody')?.children;
            const arrayFromCells = [...bookingTable];
            const dateBegin = arrayFromCells[1].querySelector('.dato')?.innerText;
            const dateEnd = arrayFromCells[2].querySelector('.dato')?.innerText;
            widgetData.dateBegin = dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            // Booking ID
            const bookingId = arrayFromCells?.[3]?.querySelector('.dato')?.innerText;
            widgetData.bookingId = bookingId;
            // Price & Currency
            const priceElUnformated = (arrayFromCells?.[18] ?? arrayFromCells?.[17])?.querySelector('.preciostotal')?.textContent;
            const priceElSplit = priceElUnformated?.split(' ');
            widgetData.price = thn.dataLayerHelper.get('amount') || thn.parseNumber(priceElSplit?.[0]);
            widgetData.currency = thn.getCurrencyCode(priceElSplit?.[1]);
            // Promocode
            const tableEls = document.querySelectorAll('.campo');
            const promoEl = tableEls.length && [...tableEls].filter((el) => el?.textContent?.match(/promo/));
            const promocode = (promoEl.length && promoEl[0]?.nextElementSibling?.textContent?.split(' ')[0])
                || (dataPurchase && dataPurchase[2]?.items?.[0]?.coupon);
            if (!thn.empty(promocode)) {
                widgetData.promocode = promocode;
            }
            widgetData.set = true;
        }
        else if (bookingIdV2) {
            widgetData.bookingId = bookingIdV2;
            const infoBookingElm = document.querySelector('.row .px-2 .shadow div.col-sm-6:nth-child(1) > div:nth-child(2)');
            const dateBeginText = infoBookingElm.querySelector('p:nth-child(1)')?.textContent?.match(/(\d+)\D+(\d+)\D+(\d+)/)?.[0];
            const dateEndText = infoBookingElm.querySelector('p:nth-child(2)')?.textContent?.match(/(\d+)\D+(\d+)\D+(\d+)/)?.[0];
            widgetData.dateBegin = dateBeginText?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEndText?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.price = thn.parseNumber(document.querySelector('.abp-widget-wrapper .row .row>.d-flex p:nth-child(3)')?.textContent);
            widgetData.currency = thn.parseCurrency(document.querySelector('#currencyDropDownId a.selected')?.textContent);
        }
        else {
            widgetData.set = false;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_222
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promo = document.querySelector('#listado-codigo-promo')?.innerText?.trim();
        if (promo) {
            ctx.promocode = promo;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
